import {get} from 'lodash';
import {CONTACT_US} from './constants';
import {LOADING} from '../constants';

export const isContactUsLoadingSelector = (state) => {
    return get(state, [CONTACT_US, LOADING]);
};
